module.exports = __webpack_public_path__ + "img/project_3.2960a1a7.png";